import { ConnectedAccountResponseDto } from '@helios/frontend-api-v2-client';
import { Button, ModalV3, useTranslation } from '@helios/frontend-core';

import { useState } from 'react';
import { useCredentialUpdateSession } from '../../../api/connected-accounts/useCredentialUpdateSession';
import { useTakeoverContext } from '../../../components/_app/TakeoverProvider/TakeoverContext';

import { ModalV3Id, useModalV3Context } from '@helios/frontend-project';
import { TakeoverId } from '../../../hooks/useTakeover';

interface ArcadiaActionsModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  account: ConnectedAccountResponseDto;
  parentTrackingId: string;
}

const TRACKING_ID = 'arcadia-connected-account';

export const ArcadiaActionsModal = (props: ArcadiaActionsModalProps) => {
  const { isOpen, onDismiss, account, parentTrackingId } = props;
  const { t } = useTranslation();
  const { openTakeover } = useTakeoverContext();
  const { openModalV3 } = useModalV3Context();
  const { getCredentialUpdateUrl } = useCredentialUpdateSession();
  const [isLoadingCredentialUpdate, setIsLoadingCredentialUpdate] = useState(false);

  const handleUpdateCredentialsClick = async () => {
    setIsLoadingCredentialUpdate(true);
    try {
      const result = await getCredentialUpdateUrl({ id: account._id });
      const credentialUpdateUrl = result?.updateUrl;
      onDismiss();
      openTakeover(TakeoverId.UTILITY_CONNECT, {
        credentialUpdateUrl,
        propertyId: account.propertyId,
        providerId: account.utilityProvider?.id,
        connectedAccountId: account._id,
      });
      setIsLoadingCredentialUpdate(false);
    } catch (error) {
      setIsLoadingCredentialUpdate(false);
      throw error;
    }
  };

  return (
    <ModalV3 open={isOpen} onClose={onDismiss} trackingId={`${parentTrackingId}-${TRACKING_ID}`}>
      <div className="flex flex-col gap-12">
        <Button
          trackingId={`${parentTrackingId}-${TRACKING_ID}-update-credentials`}
          onClick={handleUpdateCredentialsClick}
          loading={isLoadingCredentialUpdate}
        >
          {t('connectedAccounts.updateCredentials')}
        </Button>
        <Button
          emphasis="secondary"
          trackingId={`${parentTrackingId}-${TRACKING_ID}-remove-connection`}
          onClick={() => openModalV3(ModalV3Id.ARCADIA_REMOVE_CONFIRMATION, { account, parentTrackingId })}
        >
          {t('connectedAccounts.removeConnection')}
        </Button>
      </div>
    </ModalV3>
  );
};
